import { getAPIPayload } from "../../apis/getApi";
import { postAPIPayload } from "../../apis/postApi";

export const SERVICER_FULFILLMENT_API = {
  list: "service-provider/fulfillment-assignments",
  agreement: "service-provider/fulfillment-agreement",
  acknowledgeAgreement: "service-provider/fulfillment-agreement/acknowledge",
  territories: "service-provider/fulfillment-territories",
  joinTerritory: (id) => `service-provider/fulfillment-territories/${id}/join`,
  leaveTerritory: (id) => `service-provider/fulfillment-territories/${id}/leave`,
  accept: (id) => `service-provider/fulfillment-assignments/${id}/accept`,
  decline: (id) => `service-provider/fulfillment-assignments/${id}/decline`,
  client: (userId) => `service-provider/customer/users/${userId}`,
};

export const buildFulfillmentUccWorkspacePath = (
  clientUserId,
  propertyId = null,
) => {
  const userId = Number(clientUserId);
  if (!Number.isInteger(userId) || userId <= 0) {
    return "/fulfillment-assignments";
  }
  const params = new URLSearchParams();
  if (propertyId) {
    params.set("propertyId", String(propertyId));
  }
  const query = params.toString();
  return `/fulfillment/clients/${userId}${query ? `?${query}` : ""}`;
};

const fulfillmentClientFromResponse = (response) => {
  const data = response?.data;
  if (data && !Array.isArray(data) && (data.id || data.user_id || data.email)) {
    return data;
  }
  if (data?.user) {
    return data.user;
  }
  if (Array.isArray(data) && data[0]) {
    return data[0];
  }
  return null;
};

export const fetchFulfillmentClient = async (userId) => {
  const response = await getAPIPayload({
    url: SERVICER_FULFILLMENT_API.client(userId),
    token: true,
  });

  if (response?.statuscode === 428) {
    const error = new Error(
      response?.message ||
        response?.data?.message ||
        "Acknowledge the territory fulfillment agreement first.",
    );
    error.statuscode = 428;
    throw error;
  }

  if (!response?.success) {
    const error = new Error(
      response?.message ||
        response?.data?.message ||
        "Client not found or you do not have access.",
    );
    error.statuscode = response?.statuscode;
    throw error;
  }

  return fulfillmentClientFromResponse(response);
};

export const fetchFulfillmentAgreement = () =>
  getAPIPayload({
    url: SERVICER_FULFILLMENT_API.agreement,
    token: true,
  });

export const acknowledgeFulfillmentAgreement = () =>
  postAPIPayload({
    url: SERVICER_FULFILLMENT_API.acknowledgeAgreement,
    data: {},
    token: true,
  });

export const fetchFulfillmentAssignments = (page = 1) =>
  getAPIPayload({
    url: SERVICER_FULFILLMENT_API.list,
    data: { page },
    token: true,
  });

export const fetchFulfillmentPendingCount = () =>
  getAPIPayload({
    url: `${SERVICER_FULFILLMENT_API.list}/pending-count`,
    token: true,
  });

export const acceptFulfillmentAssignment = (id) =>
  postAPIPayload({
    url: SERVICER_FULFILLMENT_API.accept(id),
    data: {},
    token: true,
  });

export const declineFulfillmentAssignment = (id, reason = "") =>
  postAPIPayload({
    url: SERVICER_FULFILLMENT_API.decline(id),
    data: { reason },
    token: true,
  });

export const fetchConnectStatus = () =>
  getAPIPayload({
    url: "service-provider/payouts/connect/status",
    token: true,
  });

export const createConnectAccount = (data = {}) =>
  postAPIPayload({
    url: "service-provider/payouts/connect/account",
    data,
    token: true,
  });

export const fetchFulfillmentEarnings = (page = 1) =>
  getAPIPayload({
    url: "service-provider/payouts/earnings",
    data: { page },
    token: true,
  });

export const fetchFulfillmentTerritories = () =>
  getAPIPayload({
    url: SERVICER_FULFILLMENT_API.territories,
    token: true,
  });

/**
 * Omitting countyIds covers the whole state, including counties added later.
 */
export const joinFulfillmentTerritory = (territoryId, countyIds = null) =>
  postAPIPayload({
    url: SERVICER_FULFILLMENT_API.joinTerritory(territoryId),
    data: countyIds ? { county_ids: countyIds } : {},
    token: true,
  });

export const leaveFulfillmentTerritory = (territoryId) =>
  postAPIPayload({
    url: SERVICER_FULFILLMENT_API.leaveTerritory(territoryId),
    data: {},
    token: true,
  });
